// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"790":"3efa02aeaf84d88a","6725":"17759c4acff4523f","6851":"7ac4dc26a1c66593"}[chunkId] + ".css";
};